<div style="display: none">
  <ng-template #hiddenComponentViewContainer></ng-template>
</div>
<ng-container *abcLet="this.frameConfigObservable$ | async as config">
  <div (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
    <mat-sidenav-container
      hasBackdrop="{{ config?.hasBackdrop }}"
      [ngClass]="sideNav.opened || sideNavStillOpened ? 'sideNavContainerSideNavOpen' : 'sideNavContainer'"
    >
      <mat-sidenav
        class="slideNav"
        [position]="frame?.rtlEnabled ? 'end' : 'start'"
        #sideNav
        fixedInViewport
        autoFocus="false"
        (openedChange)="sideNavStillOpened = $event"
      >
        <abc-splitter
          #splitter
          class="splitter"
          [minWidth]="200"
          [width]="300"
          style="width: 100%; max-width: calc(100vw - 200px)"
        >
          <button class="closeSideNavButtonLeft" (click)="this.sideNav.close()"></button>
          <button
            class="closeSideNavButton"
            [ngClass]="frame?.rtlEnabled ? 'closeSideNavButtonRtl' : ''"
            (click)="this.sideNav.close()"
          >
            <mat-icon [svgIcon]="res.svgName('SideNav-Close-Image')"></mat-icon>
          </button>
          <legend-component class="legend-container" [rtlEnabled]="frame.rtlEnabled"></legend-component>
        </abc-splitter>
      </mat-sidenav>
      <mat-sidenav-content class="sideNavContent">
        <map-component [rtlEnabled]="frame.rtlEnabled" class="mapStyle"></map-component>
        <button
          mat-mdc-raised-button
          [matTooltip]="isMobileEnv ? '' : res.get('Legend')"
          [ngClass]="frame?.rtlEnabled ? 'menuButton_right_Rtl' : ''"
          class="menuButton"
          (click)="sideNav.toggle()"
        >
          <mat-icon [svgIcon]="res.svgName('Legend-OpenClose-Image')"></mat-icon>
        </button>
        <mat-card [ngClass]="frame?.rtlEnabled ? 'search_Rtl' : 'search'">
          <abcAutoCompleteWithCoords
            #abcAutoCompleteInput
            small="true"
            id="globalSearchFrame"
            class="searchFrameInput"
            [items]="allAutocompleteItems"
            [panelBehaviour]="AutoCompletePanelBehaviour.OpenWhenTyping"
            [clearAfterSubmit]="false"
            [closePanelAfterSubmit]="true"
            [hideUnderline]="true"
            (submit)="globalSearch($event)"
            (coordinateSelected)="onCoordinateSelected($event)"
            (clearCoordinateMarkers)="onClearCoordinateMarkers()"
          >
          </abcAutoCompleteWithCoords>
          <mat-icon [svgIcon]="res.svgName('SearchMap-Image')" class="searchIcon" (click)="globalSearch()"></mat-icon>
        </mat-card>

        <button
          mat-mdc-raised-button
          [matTooltip]="res.get('Menu')"
          class="menuButton"
          [ngClass]="frame?.rtlEnabled ? 'menuButton_right' : 'menuButton_Left'"
          [matMenuTriggerFor]="appMenu"
          (menuOpened)="onMenuOpen()"
          (menuClosed)="onMenuClose()"
          #menuTrigger="matMenuTrigger"
        >
          <mat-icon
            class="menuIconColor"
            [svgIcon]="isMenuOpened ? res.svgName('ExpandMore-Image') : res.svgName('Menu-Image')"
          ></mat-icon>
        </button>

        <mat-menu #appMenu="matMenu" class="mapFrameMenu">
          <mat-list>
            @if (loginInfoObservable$ | async; as loginInfo) {
              @if (isStandalone) {
                <div class="AuthMenuRow" id="LoginMenuRow">
                  <mat-icon [svgIcon]="res.svgName('User-Image')" class="profileIcon"></mat-icon>
                  <label
                    class="matitem-logged-user"
                    [ngClass]="{
                      matItemSettingDisabled: !canLogout(),
                    }"
                    [matTooltip]="res.get('RegisteredUser')"
                  >
                    @if (!loginInfo.isPublicAccess) {
                      {{ loginInfo.displayName }}
                    }
                  </label>
                  <button
                    id="systemInfoButton"
                    mat-icon-button
                    [matTooltip]="res.get('SystemInfo')"
                    (click)="openSystemInfoComponent()"
                    class="icon_button"
                    [disabled]="!canLogout()"
                  >
                    <mat-icon [svgIcon]="res.svgName('SystemInfo-Image')"></mat-icon>
                  </button>
                  @if (!loginInfo.isPublicAccess) {
                    <button
                      id="userSettingsButton"
                      mat-icon-button
                      [matTooltip]="res.get('UserSettings')"
                      (click)="openUserSettingsComponent()"
                      class="icon_button"
                      [disabled]="!canLogout()"
                    >
                      <mat-icon [svgIcon]="res.svgName('Settings-Image')"></mat-icon>
                    </button>
                  }
                  <button
                    id="logoutButton"
                    mat-icon-button
                    [matTooltip]="res.get('Logout')"
                    (click)="logout($event.ctrlKey || $event.metaKey)"
                    class="icon_button"
                    [disabled]="!canLogout()"
                  >
                    <mat-icon [svgIcon]="res.svgName('Logout-Image')"></mat-icon>
                  </button>
                </div>
              }
              @if (areProfilesSupported && (profileInfoObservable$ | async); as profileInfo) {
                @if (isStandalone) {
                  <div class="AuthMenuRow" id="ProfileMenuRow">
                    <label
                      class="matitem-current-profile"
                      [ngClass]="{
                        matItemSettingDisabled: !canSelectProfile(),
                      }"
                      [matTooltip]="res.get('CurrentUserProfile')"
                      >{{ profileInfo.displayText }}</label
                    >
                    <button
                      id="selectProfileButton"
                      mat-icon-button
                      [matTooltip]="res.get('ChooseUserProfile')"
                      (click)="selectProfile()"
                      class="icon_button"
                      [disabled]="!canSelectProfile()"
                    >
                      <mat-icon [svgIcon]="res.svgName('ChangeProfile-Image')"></mat-icon>
                    </button>
                  </div>
                }
                <div class="AuthMenuRow">
                  <label class="matitem-help" [matTooltip]="res.get('Help')">
                    {{ res.get('Help') }}
                  </label>
                  <button id="selectHelpButton" mat-icon-button [matTooltip]="res.get('GetHelp')" (click)="openHelp()">
                    <mat-icon [svgIcon]="res.svgName('Help-Image')" class="helpIcon"></mat-icon>
                  </button>
                </div>
              }
              <mat-divider></mat-divider>
            }

            @for (group of config?.groupedSettings | keyvalue; track group) {
              @if (group.key) {
                <button
                  (click)="$event.stopPropagation()"
                  class="matItemHeaderMenu"
                  mat-button
                  [matMenuTriggerFor]="menu"
                >
                  {{ group.key + ' ...' }}
                  <!-- <mat-icon style="font-size: 20px">play_arrow</mat-icon> -->
                </button>
                <mat-menu #menu="matMenu">
                  @for (setting of getSortedSettings(group.value); track setting) {
                    @if (setting.visible) {
                      <div class="matItemSetting ImportItemSetting">
                        <label
                          [ngClass]="{
                            matItemSettingDisabled: !setting.enabled,
                            matItemSettingBold: setting.captionStyle === CaptionStyle.Bold,
                          }"
                          (click)="setting.action()"
                          >{{ setting.caption }}</label
                        >
                        @switch (setting.visualRepresentation) {
                          @case (0) {
                            <mat-slide-toggle
                              [disabled]="!setting.enabled"
                              [checked]="setting.value"
                              (click)="$event.stopPropagation()"
                              (change)="setting.value = $event.checked"
                            ></mat-slide-toggle>
                          }
                          @case (1) {
                            <mat-checkbox [disabled]="!setting.enabled" [(ngModel)]="setting.value"> </mat-checkbox>
                          }
                          @case (2) {
                            <button
                              mat-icon-button
                              [disabled]="!setting.enabled"
                              class="setting_button icon_button"
                              (click)="setting.action()"
                            >
                              <mat-icon [svgIcon]="setting.svgIconName"></mat-icon>
                            </button>
                          }
                        }
                      </div>
                    }
                  }
                </mat-menu>
              }
              @if (group.key === '') {
                @for (setting of getSortedSettings(group.value); track trackById($index, setting)) {
                  @if (setting.visible) {
                    <div class="matItemSetting">
                      <label
                        [ngClass]="{
                          matItemSettingDisabled: !setting.enabled,
                          matItemSettingBold: setting.captionStyle === CaptionStyle.Bold,
                        }"
                        >{{ setting.caption }}</label
                      >
                      @switch (setting.visualRepresentation) {
                        @case (0) {
                          <mat-slide-toggle
                            [disabled]="!setting.enabled"
                            [checked]="setting.value"
                            (click)="$event.stopPropagation()"
                            (change)="setting.value = $event.checked"
                          ></mat-slide-toggle>
                        }
                        @case (1) {
                          <mat-checkbox [disabled]="!setting.enabled" [(ngModel)]="setting.value"> </mat-checkbox>
                        }
                        @case (2) {
                          <button
                            mat-icon-button
                            [disabled]="!setting.enabled"
                            class="setting_button icon_button"
                            (click)="setting.action()"
                          >
                            <mat-icon [svgIcon]="setting.svgIconName"></mat-icon>
                          </button>
                        }
                      }
                      @if (setting.beginGroupBehind) {
                        <mat-divider class="divider"></mat-divider>
                      }
                    </div>
                  }
                }
              }
            }
          </mat-list>
        </mat-menu>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
  <div class="bottomBar" (window:resize)="onResizeBottomSheetElement()">
    <mat-toolbar color="primary" class="matToolbar" [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'">
      <mat-toolbar-row class="matToolbarRow">
        <mat-button-toggle-group #group="matButtonToggleGroup" class="bottomBarToogleButtonGroup">
          @for (w of config?.visibleWidgets(); track w) {
            <mat-button-toggle
              mat-raised-button
              [ngStyle]="{ width: 100 / config?.visibleWidgets().length + '%' }"
              [ngClass]="{
                bottomBarToogleButton: true,
                disabledButton: !mapInfosLoaded,
              }"
              (click)="toggleBottomSheet(w)"
            >
              <div fxLayout="column" fxLayoutAlign="center center" class="bottomButtonContent">
                <mat-icon
                  matBadge="{{ w.badgeValueExpression ? w.badgeValueExpression() : null }}"
                  matBadgeColor="warn"
                  matBadgeSize="medium"
                  [svgIcon]="w.svgIconName"
                  class="bottomBarButtonIcon"
                >
                </mat-icon>
              </div>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
</ng-container>

<abc-popup [(visible)]="showSystemInfo" [width]="390" [height]="'auto'">
  <div fxLayout="column" fxLayoutAlign="center center" class="system-info-popup">
    <mat-icon class="matIconColor" [svgIcon]="res.svgName('SystemInfo-Image')"></mat-icon>
    <h2 class="system-info-title">{{ res.get('SystemInfo') }}</h2>
    <hr class="system-info-separator" />
    <div class="system-info-grid">
      <span class="system-info-label">{{ res.get('Version') }}</span>
      <span class="system-info-value">{{ systemVersionInfo.version }}</span>
      <button
        mat-icon-button
        class="copy-button"
        [disableRipple]="true"
        (click)="copyToClipboard(systemVersionInfo.version)"
      >
        <mat-icon class="mat-icon-copy" [svgIcon]="res.svgName('CopyVersion-Image')"></mat-icon>
      </button>

      <span class="system-info-label">{{ res.get('Build') }}</span>
      <span class="system-info-value">{{ systemVersionInfo.fullVersion }}</span>
      <button
        mat-icon-button
        class="copy-button"
        [disableRipple]="true"
        (click)="copyToClipboard(systemVersionInfo.fullVersion)"
      >
        <mat-icon class="mat-icon-copy" [svgIcon]="res.svgName('CopyVersion-Image')"></mat-icon>
      </button>

      <span class="system-info-label">{{ res.get('BuildDate') }}</span>
      <span class="system-info-value">{{ systemVersionInfo.buildDate }}</span>
      <span></span>
    </div>
    <hr class="system-info-separator" />
    <button class="system-info-close-btn" (click)="closeSystemInfo()">
      {{ res.get('Ok') }}
    </button>
  </div>
</abc-popup>
<!-- used e.g. in lib.service -->
<div #abcWindowContainer></div>
